module.exports = __webpack_public_path__ + "img/introduce3.ef1f6748.png";